import * as Api from '@ViewModels';
import { useMemo } from 'react';
import { getPrimaryEmailAddress } from '../../../../../extViewmodels/Utils';

export const getPeopleTableDisplayName = (principal: Api.IPrincipal) => {
	if (!principal) {
		return '';
	}

	if (!!principal.firstName && !principal.lastName) {
		const firstName = principal.firstName;
		return firstName;
	}

	if (!!principal.firstName && !!principal.lastName) {
		if (principal.lastName.toLowerCase().trim() === 'n/a') {
			const principalFirstName = principal.firstName;
			return principalFirstName;
		}

		const firstName = principal.firstName;
		const lastName = principal.lastName;
		return `${firstName} ${lastName}`;
	}

	const primaryEmail = getPrimaryEmailAddress(principal);
	if (primaryEmail) {
		return primaryEmail.value;
	}

	return '';
};

export const usePeopleTableDisplayName = (principal: Api.IPrincipal) => {
	return useMemo(() => getPeopleTableDisplayName(principal), [principal]);
};
